/**
 * @generated SignedSource<<9be4c4b943c76f144c262379b31accd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type UpdateRuleInputObject = {
  accountIds?: ReadonlyArray<string> | null | undefined;
  caseSensitive?: boolean | null | undefined;
  destinationBankAccountId?: string | null | undefined;
  direction?: string | null | undefined;
  enabled?: boolean | null | undefined;
  endDate?: any | null | undefined;
  expenseNatureId?: string | null | undefined;
  matchKind?: string | null | undefined;
  overrideTxnIds?: ReadonlyArray<string> | null | undefined;
  reattributeScope?: string | null | undefined;
  regex?: string | null | undefined;
  ruleId: string;
  stakeholderId?: string | null | undefined;
  stakeholderName?: string | null | undefined;
  startDate?: any | null | undefined;
  targetClassification?: TxnClassificationEnum | null | undefined;
};
export type ruleConflictDialog_UpdateRuleMutation$variables = {
  input: UpdateRuleInputObject;
};
export type ruleConflictDialog_UpdateRuleMutation$data = {
  readonly updateRule: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
      readonly matchKind: string;
      readonly matchesCount: number;
      readonly regex: string;
    } | null | undefined;
  } | null | undefined;
};
export type ruleConflictDialog_UpdateRuleMutation = {
  response: ruleConflictDialog_UpdateRuleMutation$data;
  variables: ruleConflictDialog_UpdateRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "regex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchKind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchesCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleConflictDialog_UpdateRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRuleMutationPayload",
        "kind": "LinkedField",
        "name": "updateRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ruleConflictDialog_UpdateRuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRuleMutationPayload",
        "kind": "LinkedField",
        "name": "updateRule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "523ad3a0c6edd733a1b14a9851392bf8",
    "id": null,
    "metadata": {},
    "name": "ruleConflictDialog_UpdateRuleMutation",
    "operationKind": "mutation",
    "text": "mutation ruleConflictDialog_UpdateRuleMutation(\n  $input: UpdateRuleInputObject!\n) {\n  updateRule(input: $input) {\n    rule {\n      id\n      regex\n      matchKind\n      matchesCount\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f118acb1f000f8c918fa77e3a3a7c5b7";

export default node;
